import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { AppDispatch } from "../store";
import { isString, isEmptyString } from "../util/variableTypes";
import { ProductAPI } from "../util/API";
import { getErrorString } from "../util/helpers";
import type { ParamName } from "../util/API";
import type { IProduct } from "../store/types";

type ProductsSearchState = {
  list: IProduct[];
  loading: boolean;
  error: string;
};

const initialState: ProductsSearchState = {
  list: [],
  loading: false,
  error: "",
};

const productSearchSlice = createSlice({
  name: "productSearch",
  initialState,
  reducers: {
    start: (state, action: PayloadAction<string>): ProductsSearchState => ({
      ...state,
      list: [],
      loading: true,
      error: "",
    }),
    fail: (state, action: PayloadAction<string>): ProductsSearchState => ({
      ...state,
      list: [],
      loading: false,
      error: action.payload,
    }),
    success: (state, action: PayloadAction<IProduct[]>): ProductsSearchState => ({
      ...state,
      list: action.payload,
      loading: false,
      error: "",
    }),
    clear: (state): ProductsSearchState => ({
      ...state,
      list: [],
      loading: false,
      error: "",
    }),
  },
});
const { fail, success, start, clear } = productSearchSlice.actions;
export default productSearchSlice.reducer;

export const arrayUniqueByKey = (array: IProduct[], key: string) => [
  ...new Map(array.map((item) => [item[key], item])).values(),
];

export const fetchProducts = (query: ParamName) => {
  return async (dispatch: AppDispatch) => {
    dispatch(start(query));
    const params = [];
    if (query && isString(query) && !isEmptyString(query)) {
      params.push(`name_contains=${query}`);
    }
    ProductAPI.search(params.join("&"))
      .then((response) => {
        const err = getErrorString(response);
        if (!err) {
          const list = response.result;
          const products = arrayUniqueByKey(list, "_id");
          dispatch(success(products));
        } else {
          dispatch(fail(query));
        }
      })
      .catch((error) => {
        dispatch(fail(query));
      });
  };
};

export const clearProducts = () => {
  return async (dispatch: AppDispatch) => {
    dispatch(clear());
  };
};
